import { getKycByExternalId, getLoanById } from '@nemuru-eng/js-api-client';

import { ApplicationParticipant } from '@/config/types';
import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { findCurrentParticipantOnboardingDetailsByOnboardingDetailsId } from '@/utils/findCurrentParticipantOnboardingDetails';

interface UseKycInformationProps {
  loanId: string;
}

export const useKYCInformation = ({ loanId }: UseKycInformationProps) => {
  const {
    state: { applicationParticipant },
  } = usePageContext();

  const { data: loan, loading: loadingGetLoanById } = useCache(getLoanById, { loanId });

  const { loading: loadingGetKycByExternalId } = useCache(getKycByExternalId, { loanId }, { fallbackData: undefined });

  const currentParticipantOnboardingDetails: ApplicationParticipant['onboardingDetails'] | undefined =
    findCurrentParticipantOnboardingDetailsByOnboardingDetailsId({
      loan,
      onboardingDetailsId: applicationParticipant.onboardingDetails?.id,
    });

  const loading = loadingGetKycByExternalId || loadingGetLoanById;

  return {
    loan,
    currentParticipantOnboardingDetails,
    loading,
  };
};
